import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

import OneAsyncSelectToRuleThemAll from '../../../shared/components/one_async_select_to_rule_them_all.jsx'

class SearchOrganizations extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      value: props.value || null, // Store full option object, not just ID
      loadedOptions: [] //Keep track of loaded options
    }
  }

  getOrganizations = (input) => {
    return fetch(`${this.props.loadPath}?search=${input || ""}`, { credentials: 'same-origin' }).
      then((response) => {
        return response.json();
      }).
      then((json) => {
        const options = json.map((option) => {
          return {
            value: option.id,
            label: `${option.member_number} - ${option.name}`
          }
        });
        this.setState({ loadedOptions: options });
        
        console.log("🔍 Loaded organization options:", options);
        return options;
      });
  }

  onChange = (option) => {
    if( !option ) { return; }
    this.setState({ value: option.value }, () => {
      this.props.onChange({
        id: option.value,
        organizationNumber: option.label.split(" - ")[0],
        organizationName: option.label.split(" - ")[1]
      });
    });
  }

  render() {
    return (
      <OneAsyncSelectToRuleThemAll.Base
        labelText="Search for Organization"
        tabIndex={ this.props.tabIndex }
        value={ this.state.value }
        onChange={ this.onChange }
        loadOptions={ this.getOrganizations }
        valueKey="value"
        labelKey="display"
        simpleValue={ false }
        defaultOptions={ true }
      />
    )
  }
}

SearchOrganizations.propTypes = {
  loadPath: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,

  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])

}

SearchOrganizations = connect(
  (state, props) => ({
    loadPath: state.rails.asyncHelpers.organizations
  })
)(SearchOrganizations)

export default SearchOrganizations
